import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import type { OrganizationType } from '@/types/session';

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});

/** Map organization type + user type to default route */
function getDefaultRoute(orgType: OrganizationType, userType: string | null): string {
  // Employee users go to /e regardless of org type
  if (userType === 'EMPLOYEE') return '/e';

  switch (orgType) {
    case 'WORKPAY':
      return '/w/home';
    case 'TENANT':
      // /t/ index does status-driven redirects (ONBOARDING → /t/requested-details,
      // CONTRACT_REVIEW_PENDING → /t/contracts, otherwise → /t/home).
      return '/t/';
    case 'PARTNER':
      return '/p';
  }
}

function IndexRedirect() {
  const navigate = useNavigate();
  const organizationType = useAuthStore((s) => s.organizationType);
  const userType = useAuthStore((s) => s.userType);

  useEffect(() => {
    if (organizationType) {
      // Post-login deep-link return is handled by the BFF (it redirects to
      // ?redirect_to= after the OAuth callback). The index route only needs
      // the persona-based default.
      void navigate({ to: getDefaultRoute(organizationType, userType), replace: true });
    }
  }, [organizationType, userType, navigate]);

  return null;
}
